import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { getTimeStampForLeads } from "../utils/moment";
import { contactAdapter } from "../utils/contacts";
import { Payment } from "../interfaces";
/** Estado del store */
interface PaymentsState {
  payments: Payment[];
  setPayments: (payments: Payment[]) => void;
  getPayment: (id: string) => Payment | undefined;
}

function formatCurrency(amount: number, currency: string): string {
  const formattedAmount = (amount / 100).toFixed(2);
  return amount && currency
    ? Intl.NumberFormat("en-US").format(Number(formattedAmount)) +
        " " +
        currency.toUpperCase()
    : "";
}

function calculateExchangeRate(exchangeRate: number): string {
  const er = (1 / exchangeRate).toFixed(4);
  return er;
}

/** Store sin persistencia */
export const usePaymentsStore = create<PaymentsState>()(
  subscribeWithSelector(
    devtools((set, get) => ({
      payments: [],
      setPayments: (payments: any) =>
        set((state) => ({
          ...state,
          payments: payments.map((p: any) => {
            return {
              id: p._id,
              amount: formatCurrency(p.amount, p.currency),
              date: getTimeStampForLeads(p.createdAt),
              company: p.companies[0]?.name || "",
              paymentStatus: p.paid ? "paid" : p.active ? "active" : "expired",
              transferStatus: p.transfered ? "transfered" : "pendingTransfer",
              refundStatus: p.refunded ? "refunded" : "pendingRefund",
              convertedAmount: formatCurrency(
                p.balance?.amount,
                p.balance?.currency
              ),
              exchangeRate: calculateExchangeRate(p.balance?.exchangeRate),
              totalsFees: formatCurrency(p.balance?.fee, p.balance?.currency),
              netAmount: formatCurrency(p.balance?.net, p.balance?.currency),
              contact: contactAdapter(p.contacts[0], {}),
              bookings: p.bookings?.map((b: any) => ({
                externalId: b.externalId,
                amountPaid: formatCurrency(b.amountPaid, p.currency),
                grandTotal: formatCurrency(b.grandTotal, p.currency),
              })),
            };
          }),
        })),
      getPayment: (id) => get().payments.find((p) => p.id === id),
    }))
  )
);
